module.exports = __webpack_public_path__ + "img/marker_four_blue1.25f8c36d.png";